export const WIZARD_TRAINING_BODYCOPY =
  'Please answer a few questions to help us provide you with the required trainings you need to complete to receive your Certificate of Completion.'
export const WIZARD_TRAINING_BUTTON_TEXT = 'GET STARTED'
export const WIZARD_TRAINING_HEADER = 'Which trainings do I take?'
